import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Modal extends Component {
	componentDidMount (){
		document.addEventListener('keydown', this.handleKeyDown, false);
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.isOpened !== this.props.isOpened) {
			const bodyNode = document.getElementsByTagName('body')[0];
			nextProps.isOpened ? bodyNode.classList.add('overflow-hidden') : bodyNode.classList.remove('overflow-hidden');
		}
	}

	componentWillUnmount () {
		document.removeEventListener('keydown', this.handleKeyDown, false);
	}

	handleCloseClick = (e) => {
		e.preventDefault();

		this.props.onCloseClick();
	}

	handleKeyDown = (e) => {
		if (e.keyCode === 27 && this.props.isOpened) {
			this.props.onCloseClick();
		}
	}

	render () {
		const { isOpened, children, wide } = this.props;

		if (!isOpened) {
			return null;
		}
		return (
			<div className="modal-overlay">
				<div className={`modal ${wide ? 'wide' : ''}`}>
					<button type="button" className="close" aria-hidden="true" onClick={this.handleCloseClick}>&times;</button>
					<div className="modal__content">{children}</div>
				</div>
			</div>
		);
	}
}

Modal.propTypes = {
	isOpened: PropTypes.bool,
	children: PropTypes.node,
	onCloseClick: PropTypes.func.isRequired,
	wide: PropTypes.bool
}

export default Modal;



// WEBPACK FOOTER //
// ./components/Modal.js